import type { Dict } from "../core.js";
import type { common as vi } from "../vi/common.js";

export const common: Dict<typeof vi> = {
  stateOn: "Enabled",
  stateOff: "Disabled",
  loading: "Loading…",
  save: "Save",
  saving: "Saving…",
  cancel: "Cancel",
  close: "Close",
  confirm: "Confirm",
  edit: "Edit",
  delete: "Delete",
  retry: "Retry",
  refresh: "Refresh",
  back: "Back",
  search: "Search",
  none: "—",
  yes: "Yes",
  no: "No",
  allApps: "All apps",
  noData: "No data yet.",
  loadFailed: "Could not load data.",
  saveFailed: "Could not save.",
  noPermission: "You do not have permission to view this.",

  // HQ-2026-009 — router `errorElement`: a page failed to render / the path does not exist.
  "routeError.title": "This page hit an error",
  "routeError.body": "The error has been recorded for the engineering team. Try reloading; if it persists, go back to the start page.",
  "routeError.notFoundTitle": "Page not found",
  "routeError.notFoundBody": "This path does not exist or has moved.",
  "routeError.reload": "Reload page",
  "routeError.home": "Go to start page",
  "routeError.detail": "Technical details",

  "connectorStatus.ok": "Running",
  "connectorStatus.not_configured": "Not configured",
  "connectorStatus.unreachable": "Unreachable",
  "connectorStatus.schema_drift": "Schema drift",
  "connectorStatus.never_run": "Never run",
  "connectorStatus.disabled": "Disabled",

  "criticality.tier_0": "Critical",
  "criticality.tier_1": "Important",
  "criticality.tier_2": "Standard",
  "criticality.tier_3": "Auxiliary",

  "ownerKind.product": "Product",
  "ownerKind.engineering": "Engineering",
  "ownerKind.operations": "Operations",
  "ownerKind.security": "Security",
  "ownerKind.business": "Business",

  "feedbackStatus.open": "Open",
  "feedbackStatus.in_progress": "In progress",
  "feedbackStatus.resolved": "Resolved",

  "role.hq.viewer": "Viewer",
  "role.hq.operator": "Operator",
  "role.hq.owner": "Owner",

  "audienceMetric.users.total": "Total users",
  "audienceMetric.users.new": "New users",
  "audienceMetric.users.active": "Active users",

  "period.today": "Today",
  "period.yesterday": "Yesterday",
  "period.d7": "Last 7 days",
  "period.this_week": "This week",
  "period.last_week": "Last week",
  "period.d30": "Last 30 days",
  "period.this_month": "This month",
  "period.last_month": "Last month",
  "period.d90": "Last 90 days",
  "period.custom": "Custom…",

  "partnerCategory.einvoice": "E-invoice",
  "partnerCategory.bank_feed": "Bank feed",
  "partnerCategory.payment": "Payment gateway",
  "partnerCategory.shipping": "Shipping",
  "partnerCategory.esign": "Digital signature",
  "partnerCategory.messaging": "Messaging",
  "partnerCategory.tax": "Tax",
  "partnerCategory.marketplace": "Marketplace",
  "partnerCategory.identity": "Sign-in",
  "partnerCategory.email": "Email",
  "partnerCategory.push": "Push notifications",
  "partnerCategory.ai": "AI",
  "partnerCategory.other": "Other",

  networkError: "Could not reach the server. Check your connection and try again.",
  unexpectedErrorShape: "The server returned {status} with a body that is not a hub error envelope.",
  contractMismatch: "The response from {path} does not match the contract: {issue}",
  unknownIssue: "unknown",

  "metric.users.total": "Total users",
  "metric.users.new": "New users",
  "metric.users.active": "Active users",
  "metric.subscriptions.count": "Subscriptions",
  "metric.revenue.net": "Recognized revenue",
  "metric.storage.bytes": "Storage",
  "metric.service.latency_p50": "Median latency",
};
